module.exports = __webpack_public_path__ + "img/sandbox_logo.d110985b.png";